import { AudioManager } from "../../../../AudioManager";
import { Card } from "../Card";

export class HeartEffect extends Phaser.GameObjects.Container {

    private totalHearts: number;

    constructor(card: Card) {
        
        super(card.scene);

        let x: number;
        let y: number;
        let finalX: number;

        if (card.x < 0) {
            x = 45;
            y = -110;
            finalX = 210;
        } else {
            x = 70;
            y = -80;
            finalX = -210;
        }

        const n = 2 * card.cardData.lastValue;
        this.totalHearts = n;

        for (let i = 0; i < n; i ++) {

            const heart = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_1", "heart");
            heart.angle = Phaser.Math.Between(-12, 12);
            heart.scale = 0;
            this.add(heart);

            const scale = Math.random() * .5 + .5;

            const angle = Phaser.Math.Between(0, 360);
            const dx = 50 * Math.cos(angle * Math.PI / 180);
            const dy = 50 * Math.sin(angle * Math.PI / 180);

            this.scene.tweens.add({
                targets: heart,
                scaleX: scale,
                scaleY: scale,
                x: x + dx,
                y: y + dy,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 250,
                delay: Math.random() * 250,
                onComplete: () => {

                    this.scene.tweens.add({
                        targets: heart,
                        x: finalX,
                        y: -20,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 250,
                        delay: Math.random() * 150,
                        onComplete:  () =>  {
                            this.totalHearts --;
                            if (this.totalHearts === 0) {
                                this.destroy();
                            }
                        },
                    });
                },
                onCompleteScope: this,
            });
        }
    }
}
